// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.timeSelector {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 1rem 0;
}
.timeSelector .sectionTitle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  color: #333;
}
.timeSelector .list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  max-height: 15rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.75rem;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}
.timeSelector .list::-webkit-scrollbar {
  width: 4px;
}
.timeSelector .list::-webkit-scrollbar-thumb {
  background-color: rgba(81, 85, 146, 0.2);
  border-radius: 10px;
}
.timeSelector .list .timeSlot {
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #eee;
  border-radius: 0.75rem;
  padding: 0.55rem 0.3rem;
  background-color: #ffffff;
  color: #333;
  font-weight: 600;
  font-size: 0.78rem;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.timeSelector .list .timeSlot:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.timeSelector .list .timeSlot:hover:not(.selected) {
  border-color: rgba(81, 85, 146, 0.3);
  background-color: rgba(81, 85, 146, 0.04);
  color: #515592;
}
.timeSelector .list .timeSlot.selected {
  background-color: #515592 !important;
  border-color: #515592;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(81, 85, 146, 0.3);
}
.timeSelector p {
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
  color: rgb(178, 181, 188) !important;
  opacity: 0.8;
  text-align: center;
}
.timeSelector button.submitBtn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3rem);
  background: linear-gradient(to right, #1d2239, #4657a2, #1d2239);
  color: #ffffff;
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  font-size: 1.1rem;
  line-height: 1.3rem;
  padding: 1rem 0;
  margin: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 1.25rem auto 1rem;
  text-transform: none;
  height: 3rem;
  width: 100%;
  max-width: 200px;
  border-radius: 100px;
  background: #515592 !important;
  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);
  font-weight: 500;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}
.timeSelector button.submitBtn:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.timeSelector button.submitBtn:disabled {
  background: rgb(200, 200, 200);
}
.timeSelector button.submitBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
.timeSelector button.submitBtn:hover:not(:disabled) {
  box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);
  transform: translateY(-1px);
}
.timeSelector button.submitBtn:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/TimeSelector/TimeSelector.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_click-animation.scss","webpack://./src/assets/Theme/mixins/_app-button.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,WAAA;EACA,sBAAA;EACA,oBAAA;AAqEF;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAqEJ;AAlEE;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBC3BI;ED4BJ,mBAAA;EACA,0CAAA;EACA,sBAAA;AAoEJ;AAlEI;EACE,UAAA;AAoEN;AAjEI;EACE,wCAAA;EACA,mBAAA;AAmEN;AAhEI;EAEE,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBCnDE;EDoDF,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAiEN;AExHE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AF0HJ;AApEM;EACE,oCAAA;EACA,yCAAA;EACA,cA3DQ;AAiIhB;AAnEM;EACE,oCAAA;EACA,qBAhEQ;EAiER,cCnEA;EDoEA,6CAAA;AAqER;AAhEE;EACE,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AAkEJ;AA/DE;EGhFA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gEFDe;EEEf,cFPM;EEQN,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EHqEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,8BAAA;EACA,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AA8EJ;AGlKE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AHoKJ;AGlKE;EACE,8BFdO;ADkLX;AApFI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAsFN;AAnFI;EACE,8CAAA;EACA,2BAAA;AAqFN;AAlFI;EACE,0BAAA;EACA,6CAAA;AAoFN","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme/';\n\n$brand_primary: #515592;\n\n.timeSelector {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1rem 1rem 0;\n\n  .sectionTitle {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin: 0 0 0.75rem;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #333;\n  }\n\n  .list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n    max-height: 15rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0.75rem;\n    background-color: $white;\n    border-radius: 1rem;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);\n    box-sizing: border-box;\n\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba($brand_primary, 0.2);\n      border-radius: 10px;\n    }\n\n    .timeSlot {\n      @include click-animation;\n      box-sizing: border-box;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 1.5px solid #eee;\n      border-radius: 0.75rem;\n      padding: 0.55rem 0.3rem;\n      background-color: $white;\n      color: #333;\n      font-weight: 600;\n      font-size: 0.78rem;\n      white-space: nowrap;\n      transition: all 0.2s ease;\n\n      &:hover:not(.selected) {\n        border-color: rgba($brand_primary, 0.3);\n        background-color: rgba($brand_primary, 0.04);\n        color: $brand_primary;\n      }\n\n      &.selected {\n        background-color: $brand_primary !important;\n        border-color: $brand_primary;\n        color: $white;\n        box-shadow: 0 4px 12px rgba(81, 85, 146, 0.3);\n      }\n    }\n  }\n\n  p {\n    margin: 0.75rem 0 0;\n    font-size: 0.9rem;\n    color: $text_gray !important;\n    opacity: 0.8;\n    text-align: center;\n  }\n\n  button.submitBtn {\n    @include app-button;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    margin: 1.25rem auto 1rem;\n    text-transform: none;\n    height: 3rem;\n    width: 100%;\n    max-width: 200px;\n    border-radius: 100px;\n    background: $brand_primary !important;\n    box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);\n    font-weight: 500;\n    font-size: 1.1rem;\n    transition: all 0.3s ease;\n    border: none;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n\n    &:hover:not(:disabled) {\n      box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);\n      transform: translateY(-1px);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(1px);\n      box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin click-animation() {\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n}\n","@mixin app-button() {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 3rem);\n  background: $buttonLinearBg;\n  color: $white;\n  border-radius: 2rem;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n  padding: 1rem 0;\n  margin: 1rem 1.5rem;\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n  &:disabled {\n    background: $disabled;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
